import { useRemoveWpsRibbon } from './hooks/useRemoveWpsRibbon';

// TODO: temporary — remove once the GTM-injected wps-ribbon overlay is fixed/cleaned up upstream.
export function WpsRibbonRemover() {
  useRemoveWpsRibbon();
  return null;
}
